/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteSavedReportInput = {
    id: string;
    reportService?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteSavedReportMutationVariables = {
    input: DeleteSavedReportInput;
};
export type deleteSavedReportMutationResponse = {
    readonly deleteSavedReport: {
        readonly deletedSavedReportId: string | null;
    } | null;
};
export type deleteSavedReportMutation = {
    readonly response: deleteSavedReportMutationResponse;
    readonly variables: deleteSavedReportMutationVariables;
};



/*
mutation deleteSavedReportMutation(
  $input: DeleteSavedReportInput!
) {
  deleteSavedReport(input: $input) {
    deletedSavedReportId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteSavedReportInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteSavedReportPayload",
    "kind": "LinkedField",
    "name": "deleteSavedReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedSavedReportId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteSavedReportMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteSavedReportMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteSavedReportMutation",
    "operationKind": "mutation",
    "text": "mutation deleteSavedReportMutation(\n  $input: DeleteSavedReportInput!\n) {\n  deleteSavedReport(input: $input) {\n    deletedSavedReportId\n  }\n}\n"
  }
};
})();
(node as any).hash = '54d79ae77d476868532b21124ff07801';
export default node;
